import { Component, OnInit } from '@angular/core';
import { UtilsService } from 'src/app/shared/utils.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit {

  constructor(private utils: UtilsService) { }

  ngOnInit(): void {
    this.utils.setTitle('Dashboard');
    this.utils.screenTitle.emit({firstTitle: 'Dashboard', firstRoute: '/dashboard'});
  }

}
